import React from "react";
import { openConsult } from "../lib/api";

const BG =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/dd8c0996546e3b1b_Gemini_Generated_Image_39trt39trt39trt3%20%281%29.jpg";

export default function BuiltForPartners() {
  return (
    <section className="w-full grid grid-cols-1 md:grid-cols-[2fr_3fr] md:min-h-[460px] md:h-[56vh]" data-testid="built-for-partners">
      <div className="order-2 md:order-1 bg-[#F3E9DF] flex items-center px-8 sm:px-12 lg:px-20 py-14 md:py-0">
        <div className="max-w-md" data-testid="partners-card">
          <p className="font-typewriter text-sm sm:text-base tracking-[0.35em] uppercase text-[#8B6B4A]" data-testid="partners-eyebrow">
            Licensing opportunities
          </p>
          <h2
            className="font-cormorant font-light leading-[1.05] text-[#1F1B18] mt-6"
            style={{ fontSize: "clamp(2.5rem, 4.2vw, 4.25rem)" }}
            data-testid="built-for-partners-heading"
          >
            Want to work with us?
          </h2>
          <p className="font-cormorant font-light text-xl sm:text-2xl leading-[1.5] text-[#1F1B18]/80 mt-5" data-testid="partners-line">
            We're open to the right manufacturing, licensing and distribution partners.
          </p>
          <button
            type="button"
            onClick={() => openConsult("Partner with Us")}
            data-testid="partners-cta"
            className="mt-8 inline-flex items-center gap-2 font-cormorant italic text-2xl sm:text-3xl text-[#1F1B18] border-b border-[#1F1B18]/40 pb-0.5 hover:text-[#D9739A] hover:border-[#D9739A] transition-colors duration-300"
          >
            Let's talk <span aria-hidden>→</span>
          </button>
        </div>
      </div>
      <div className="order-1 md:order-2 relative h-[300px] sm:h-[380px] md:h-auto overflow-hidden">
        <img
          src={BG}
          alt="Ask Kimberley street poster — a woman walking her dog past the disco question mark billboard"
          className="absolute inset-0 w-full h-full object-cover object-[50%_40%]"
          data-testid="partners-bg-image"
        />
      </div>
    </section>
  );
}
